<template>
  <div>
    <Topo :btnLogout="true" :acessoRestritoMenu="true"></Topo>
    <Migalha label="Dupla Conferência"></Migalha>
    <v-card>
      <v-form ref="formPesquisar">
        <v-layout row wrap>
          <!-- Campo Nacionalidade -->
          <v-flex xs12 sm4 p-t-20>
            <fieldset>
              <legend>Nacionalidade</legend>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-switch @change="defineNacionalidadeEstrangeiro"
                    v-model="conferencia.flagEstrangeiro"
                    label="Estrangeiro"
                    color="info"
                    value="1"
                    hide-details
                  ></v-switch>
                </v-flex>
              </v-layout>
            </fieldset>
          </v-flex>         
          <!-- / Campo Nacionalidade -->
        </v-layout><br />              

        <!-- Campo Família -->
        <div style="width: 50%; float: left;">
          <v-layout row wrap>
            <v-flex>
              <v-card>
                <fieldset>
                  <legend>Família</legend><br /><br />

                  <v-layout row wrap class="p-t-10 p-b-20">
                    <v-flex xs8 v-bind:class="{sm8:!modelFamilia.familia,md8:!modelFamilia.familia}">
                      <v-autocomplete
                        :disabled="isLoadComboFam"
                        :loading="isLoadComboFam"
                        hint="Digite pelo menos 3 caracteres para pesquisar."
                        :hide-no-data="hideNoData"
                        persistent-hint
                        clearable
                        @click:clear="listaFamilia=[];hideNoData=true;"
                        v-model="modelFamilia.familia"
                        :items="listaFamilia"
                        color="blue-grey lighten-2"
                        :label="$t('label.familia')+' *'"
                        item-text="descFamilia"
                        :return-object="true"
                        :search-input.sync="pesquisaFamilia"
                        required
                      >                      
                        <template slot="item" slot-scope="data">
                          <template>
                            <v-list-tile-content>
                              <v-list-tile-title v-html="data.item.descFamilia"></v-list-tile-title>
                              <v-list-tile-sub-title v-html="data.item.descGrupo"></v-list-tile-sub-title>
                            </v-list-tile-content>
                          </template>
                        </template>
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs4 sm4 md4 my-auto>
                      <v-btn 
                        slot="activator" 
                        @click="AddFamilia()" 
                        large 
                        color="primary"
                        class="mb-2"
                      >
                        Adicionar
                      </v-btn>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap>
                    <v-flex>
                      <v-data-table
                        :items="itemDataFamilia"
                        hide-actions
                        class="elevation-1"
                      >                      
                        <template v-slot:items="props">
                          <td>{{ props.item.descFamilia }}</td>
                          <td class="justify-center layout px-0">
                            <v-icon
                              medium
                              @click="deleteItem(props.item)"
                              color="red"
                            >                
                            block
                            </v-icon>
                          </td>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                </fieldset>
              </v-card>
            </v-flex>          
          </v-layout>          

          <v-dialog v-model="dialog" max-width="355" :persistent="persistent">
            <v-card>
              <v-card-title class="headline">Atenção!</v-card-title>
              <v-form>
                <v-layout row wrap>
                  <v-flex xs12><br />
                    Deseja limpar este item da lista?
                  </v-flex>
                </v-layout><br /><br />
                <v-layout wrap p-b-10>
                  <v-flex xs12 sm6>
                    <v-btn @click="cancelarDialog()">Não</v-btn>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-btn color="info" @click="apagarItem(itemDelete)" :loading="isLoading">Sim</v-btn>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card>
          </v-dialog>
        </div>
        <!-- / Campo Família -->

        <!-- Campo CPF/CNPJ -->
        <div style="width: 50%; float: left;">
          <v-layout row wrap>
            <v-flex>
              <v-card>
                <fieldset>
                  <legend>CNPJ/CPF</legend>

                  <v-layout row wrap>
                    <v-flex>
                      <v-radio-group
                        v-model="tipoFornec"
                        class="mb-0 mt-1"
                        row
                        persistent-hint
                      >
                        <v-radio label="Pessoa Jurídica" value="CNPJ"></v-radio>
                        <v-radio label="Pessoa Física" value="CPF"></v-radio>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap class="p-t-10 p-b-20">
                    <v-flex xs8>
                      <v-text-field
                        v-if="tipoFornec == 'CNPJ'"
                        key="num_CgcFornecedorCommMaskPJ"
                        v-model="numCgcFornecedor"
                        :label="$t('label.cnpj') +' *'"
                        v-mask="maskCnpj"
                        :rules="validacao.cnpj"
                        validate-on-blur
                        required
                      ></v-text-field>
                      <v-text-field
                        v-if="tipoFornec == 'CPF'"
                        key="num_CgcFornecedorCommMaskPF"
                        v-model="numCgcFornecedor"
                        :label="$t('label.cpf')+' *' "
                        v-mask="maskCpf"
                        :rules="validacao.cpf"
                        required
                        validate-on-blur
                      ></v-text-field>
                    </v-flex>
                    
                    <v-flex xs12 sm4 md4 my-auto>
                      <v-btn 
                        slot="activator" 
                        @click="AddFornec()"
                        large 
                        color="primary"
                        class="mb-2"
                      >
                        Adicionar
                      </v-btn>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap>                  
                    <v-flex>
                      <v-data-table
                        :items="itemDataFornec"
                        :headers="headersDoc"                        
                        item-key="name"
                        hide-actions
                        class="elevation-1"
                      >                      
                        <template v-slot:items="props">
                          <td style="width: 35% !important;">{{ props.item.numCgcFornecedorFormatado }}</td>
                          <td>{{ props.item.nomFornecedor }}</td>
                          <td class="justify-center layout px-0">
                            <v-icon
                              medium
                              @click="deleteItemDoc(props.item)"
                              color="red"
                            >                
                            block
                            </v-icon>
                          </td>                          
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>

                  <v-dialog v-model="dialogDoc" max-width="355" :persistent="persistent">
                    <v-card>
                      <v-card-title class="headline">Atenção!</v-card-title>
                      <v-form>
                        <v-layout row wrap>
                          <v-flex xs12><br />
                            Deseja limpar este item da lista?
                          </v-flex>
                        </v-layout><br /><br />
                        <v-layout wrap p-b-10>
                          <v-flex xs12 sm6>
                            <v-btn @click="cancelarDialogDoc()">Não</v-btn>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <v-btn 
                              color="info" 
                              @click="apagarItemDoc(itemDeleteDoc)" 
                              :loading="isLoading">
                              Sim
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-card>
                  </v-dialog>

                </fieldset>
              </v-card>
            </v-flex>          
          </v-layout>
        </div>
        <!-- / Campo CPF/CNPJ -->
        
        <div style="clear: both;"></div>
        
        <div style="float: right; margin: 20px 0">
          <v-flex>
            <v-btn @click="salvarTotal()" large color="primary">Salvar</v-btn>
          </v-flex>
        </div>

        <div style="clear: both;"></div>

        <!-- Campo Legenda rodapé-->
        <v-layout row wrap>
          <v-flex xs12 sm4 p-t-20>
            <strong>Legenda:</strong><br />
            <v-icon
              medium          
              color="red"
              style="float: left;"
            >                
            block
            </v-icon> <div style="float: left; margin: 5px 0 0 3px;">- Retirar</div>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import familiaService from "../../../services/familiaService";
import util from "../../../plugins/util";
import Migalha from "../../../components/migalha";
import fornecedorService from "../../../services/fornecedorService";
import Topo from "../../../components/Topo";
import Vue from 'vue';

export default {
  name: "dupla-conferencia",
  mixins: [util],
  components: { /*Componentes utilizados*/
    Migalha,
    Topo
  },

  async created() {
    await this.obterDuplaConferencia();
  },
  
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
  },

  data() {//Declaracao de variaveis
    return {
      modelCnpjCpf: '',
      conferencia: {
        tipoHabilitador: "F",
        flagEstrangeiro: "0",
      },
      numCgcFornecedor: null,
      btnAdd: true,
      tipoFamilia: "Todos",
      tipoFornec: "CNPJ",
      modelFamilia: {
        familia: {
          $id: null,   
        }
      },
      headersDoc: [        
        { text: 'CNPJ/CPF', sortable: false },
        { text: 'Razão Social/Nome', sortable: false },
        { text: '', sortable: false },
      ],
      mascara: null,
      isLoadComboFam: false,
      isLoadComboDoc: false,
      listaFamilia: [],
      itemDelete: null,
      itemDeleteDoc: null,
      pesquisaFamilia: null,  
      dialog: false,
      dialogDelete: false,
      dialogDoc: false,
      itemDataFamilia: [],
      itemDataFornec: [],
      fornecExistentes: [],
      familiasExistentes: [],
      deleteItemFamilia: [],
      deleteItemFornec: [],
      errors: {
        novoItem: [],
      },
      novoItem: {
        $id: null,
        descFamilia: '',
      },
      editedIndex: -1,      
    };
  },

  watch: {
    pesquisaFamilia(newValor, oldValor) {
      this.pesquisaCombo(
        newValor,
        oldValor,
        "listaFamilia",
        eval("this.listaFamilia"),
        "model.familia",
        this.getFamilia,
        2
      );
    },
  },
  
  methods: {
    async obterDuplaConferencia() {
      await fornecedorService.getDuplaConferencia().then((result) => {
        let itemFamDB = result.data.itemDataFamilia;
        
        for (let chave in itemFamDB) {
          if (itemFamDB.hasOwnProperty(chave)) {
            // Você pode fazer operações assíncronas aqui usando await, se necessário
            const valor = itemFamDB[chave].codGrupo + '.' + itemFamDB[chave].numFamilia;
            this.familiasExistentes.push(valor);
          }
        }       
        
        this.itemDataFamilia = result.data.itemDataFamilia;
      
        let itensFornec = result.data.itemDataFornec;
        itensFornec.forEach((value) => {
          this.itemDataFornec.push(value);
          this.fornecExistentes.push(value.numCgcFornecedorFormatado);
        });        
                
        if(result.data.flagEstrangeiro != 0) {
          this.conferencia.flagEstrangeiro = result.data.flagEstrangeiro;
        }        
      }); 
    },
    salvarTotal() {   
     // if(this.itemDataFamilia.length == 0 || this.itemDataFornec.length == 0 ) {
     //   Vue.toasted.error(this.$t("Adicione família(s) e documentos de CNPJ e/ou CPF"));
     //   return;
    //  }
      
      this.itemDataFornec.flag = this.conferencia.flagEstrangeiro;
      let dadosDupConf = {        
        itemDataFamilia: this.itemDataFamilia,
        itemDataFornec: this.itemDataFornec,       
      };
     
      // Criando um novo objeto com arrays mapeados
      let novoObjeto = {
        itemDataFamilia: dadosDupConf.itemDataFamilia.map(familia => {
          return {
            codGrupo: familia.codGrupo,
            numFamilia: familia.numFamilia,
            id: familia.id            
          };
        }),
        itemDataFornec: dadosDupConf.itemDataFornec.map(fornecedor => {
          return {
            numCgcFornecedor: fornecedor.numCgcFornecedor,
            nomFornecedor: fornecedor.nomFornecedor,
            id: fornecedor.id            
          };
        },         
        ),        
        flagEstrangeiro: this.itemDataFornec.flag,
        podeApagarFam: this.deleteItemFamilia.length,
        podeApagarFornec: this.deleteItemFornec.length
      };
      
      fornecedorService.cadastrarDuplaConferencia(
        novoObjeto
      )
      this.$toasted.success(this.$t("messages.dupla.sucesso")); 
    },

    cancelarDialog() {
      this.dialog = false;
    },

    cancelarDialogDoc() {
      this.dialogDoc = false;
    },

    apagarItem(item) {
      // Apagando item do array que compara valores existentes
      let itemDel = item.codGrupo + '.' + item.numFamilia;
      const index = this.familiasExistentes.indexOf(itemDel);
      this.deleteItemFamilia.push(index);
      this.familiasExistentes.splice(index, 1);      

      // Apagando item do array que preenche na grid de famílias
      const index2 = this.itemDataFamilia.indexOf(item);
      this.itemDataFamilia.splice(index2, 1);
      this.dialog = false;
    },

    apagarItemDoc(item) {
      const index = this.itemDataFornec.indexOf(item);
      const indexExistente = this.fornecExistentes.indexOf(item.numCgcFornecedor);
      this.deleteItemFornec.push(index);
     
     
        if (indexExistente !== -1) {
          this.fornecExistentes.splice(indexExistente, 1);
        }
        

      this.itemDataFornec.splice(index, 1);
      this.dialogDoc = false;
    },

    deleteItem (item) {
      this.dialog = true;
      this.itemDelete = item;      
    },

    deleteItemDoc (item) {
      this.dialogDoc = true;
      this.itemDeleteDoc= item;   
     
   
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem)
      } else {
        this.desserts.push(this.editedItem)
      }
      this.close()
    },    

    defineNacionalidadeEstrangeiro(){
      if (this.conferencia.flagEstrangeiro != "1") {
        this.conferencia.flagEstrangeiro = "0";
      }
    },    

    getFamilia(valor) {
      this.isLoadComboFam = true;
      let descricao = valor;
      familiaService.getListaFamiliaCatalagoMat(descricao).then(response => { /*resposta do servico*/
        var familiaFiltrada = [];
        if(this.tipoFamilia !== "Todos") {
          response.data.filter(item => {
            if(item.tipoItem == this.tipoFamilia ){
                familiaFiltrada.push(item);
            }
          });
          
          response.data = familiaFiltrada;
        }

        this.hideNoData = false;
        this.listaFamilia = [];
        var array = [];
        var cabecalho = { header: null };
        var separador = { divider: false };

        response.data.filter(item => {
          if (item.descGrupo !== cabecalho.header) {
             
            if (separador.divider) {
              array.push(separador);
            }
            cabecalho = { header: item.descGrupo };
            array.push(cabecalho);
          }
          item.descFamilia = item.codFamilia + " - " + item.descFamilia;
          
          array.push(item);

          separador = { divider: true };
        });
       
        this.listaFamilia = array;
        this.isLoadComboFam = false;
      })
    },

    AddFamilia() {
      if(this.modelFamilia.familia.$id === null) {
        Vue.toasted.error(this.$t("Escolha uma família para adicionar na lista"));
        return;
      }

      if (this.familiasExistentes.includes(this.modelFamilia.familia.codFamilia)) {
        Vue.toasted.error(this.$t("Já existe item na lista"));
        return;
      }
      
      // Aqui adiciona na lista famílias por código duplo, por exemplo "20.10"
      this.familiasExistentes.push(this.modelFamilia.familia.codFamilia);      

      this.itemDataFamilia.push({ ...this.modelFamilia.familia }); 
      
      this.modelFamilia.familia = {};      
      this.listaFamilia = [];
      this.hideNoData = true;
    },

    AddFornec() {
      if(this.numCgcFornecedor === null) {
        Vue.toasted.error(this.$t("Digite um CNPJ ou CPF para fazer a pesquisa e adicionar na lista"));
        return;
      }     
  
      if (this.fornecExistentes.includes(this.numCgcFornecedor)) {
        Vue.toasted.error(this.$t("Já existe item na lista"));
        this.numCgcFornecedor = null;
        return;
      }

      // Pegar os dados do fornecedor para salvar
     // this.fornecExistentes.push(this.numCgcFornecedor);

      fornecedorService
        .getFornecedorNome(this.numCgcFornecedor)
        .then((response) => {
          this.numCgcFornecedor = null;
          
          let itensFornec = response.data;

          itensFornec.forEach((value) => {
            this.itemDataFornec.push(value);
            this.fornecExistentes.push(value.numCgcFornecedorFormatado);
          });          
        })
        .catch((error) => {
          if (error.status == 403) {
            Vue.toasted.error("Acesso não permitido!");
            this.$router.push("/arearestrita/habilitador/dupla-conferencia");
          }
        });
    }
  }

};
</script>